import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AdministrationUserCreateForm, SortingCenter } from 'types';
import { AdministrationUserCreateStepProps } from './types';
import { AdministrationUserCreateStep5Schema } from './Step5.yup';
import { AppContext } from '../../../context';
import { transformObjectId } from '../../../services/apiPlatformTransformer';
import { useStyles } from './styles';
import { DialogErrorSomeUserRoleNotSelected } from '../AdministrationSortingCenterUserRolesForm/DialogErrorSomeUserRoleNotSelected';
import LinkUserRolesTooltip from '../AdministrationSortingCenterUserRolesForm/UserRolesTooltip';
import ListItemSortingCenterUserRoleCreate from './ListItemSortingCenterUserRoleCreate';

export const Step5: React.FC<AdministrationUserCreateStepProps> = ({ onSubmit, formName, previousStepData }) => {
  const context = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });
  const schema = useMemo(() => AdministrationUserCreateStep5Schema(t), [t]);

  const {
    clearErrors,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<AdministrationUserCreateForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: { ...previousStepData },
    resolver: yupResolver(schema),
  });

  const sortingCenters = context.getSortingCenters?.();
  const [isOpenDialog, setIsOpenDialog] = useState(false);

  const eligibleSortingCenter: SortingCenter[] = [];
  sortingCenters?.map((sortingCenterParent: SortingCenter, indexParent) => {
    eligibleSortingCenter.push(sortingCenterParent);
    sortingCenterParent.childrenSortingCenter?.map((sortingCenterChild: SortingCenter, indexChild) => {
      eligibleSortingCenter.push(sortingCenterChild);
      return null;
    });
    return null;
  });

  if (errors?.sortingCenterUserRole) {
    if (!isOpenDialog) setIsOpenDialog(true);
  }

  let listSortingCenterOnError: (SortingCenter | undefined)[] | undefined = [];
  if (isOpenDialog) {
    listSortingCenterOnError = getValues('sortingCenterUserRole')?.map((role: string, sortingCenterId: number) => {
      if (role) {
        return undefined;
      }
      return eligibleSortingCenter.find(sortingCenter => transformObjectId(sortingCenter) === String(sortingCenterId));
    });
  }

  const handleCloseDialog = () => {
    clearErrors();
    setIsOpenDialog(false);
  };

  return (
    <>
      <DialogErrorSomeUserRoleNotSelected
        isOpen={isOpenDialog}
        setOpen={setIsOpenDialog}
        handleCancel={handleCloseDialog}
        listSortingCenterOnError={listSortingCenterOnError}
      />
      <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
        <br />
        <LinkUserRolesTooltip />
        <br />
        <br />
        <div className={classes.divScrollRole}>
          {sortingCenters &&
            sortingCenters.map((sortingCenterParent: SortingCenter, index) => (
              <ListItemSortingCenterUserRoleCreate
                key={`sortingCenterParent.${index}`}
                sortingCenterParent={sortingCenterParent}
                previousStepData={previousStepData}
                control={control}
              />
            ))}
        </div>
      </form>
    </>
  );
};
